import Link from 'next/link';
import Image from 'next/image';
import { PostData, getCtaLabel, getPostHref, getTypeBadgeLabel } from './types';

export const VERTICAL_GRID_CLASS =
  'grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3';

export function VerticalResourceCard({ post }: { post: PostData }) {
  return (
    <Link
      href={getPostHref(post)}
      className="group flex flex-col overflow-hidden rounded-2xl border border-[#ccc] bg-white drop-shadow-[0px_1px_1px_rgba(0,0,0,0.05)] transition-shadow hover:shadow-md"
    >
      {/* Thumbnail */}
      <div className="relative aspect-video w-full overflow-hidden rounded-t-2xl">
        {post.image ? (
          <Image
            src={post.image}
            alt={post.imageAlt || post.title}
            fill
            className="absolute inset-0 size-full object-cover transition-transform duration-300 group-hover:scale-105"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        ) : (
          <div className="flex size-full items-center justify-center bg-gray-100">
            <span className="text-sm text-gray-400">No image</span>
          </div>
        )}

        {/* Frosted type badge */}
        <span
          className="absolute left-4 top-3 inline-flex items-center rounded-[20px] border border-white/70 px-2 py-0.5 text-xs font-bold uppercase text-[#eff1f3] backdrop-blur-[21px]"
          style={{
            backgroundImage:
              'linear-gradient(138deg, rgba(255,255,255,0.47) 0%, rgba(255,255,255,0) 111%)',
          }}
        >
          {getTypeBadgeLabel(post.type)}
        </span>
      </div>

      {/* Body */}
      <div className="flex flex-1 flex-col gap-2 p-4">
        {/* Topic tag with green left border */}
        {post.categoryName && (
          <div className="border-l border-[#00f557] py-1 pl-2">
            <span className="text-xs font-semibold uppercase text-[#041118]">
              {post.categoryName}
            </span>
          </div>
        )}

        {/* Title */}
        <h3 className="line-clamp-3 text-base font-semibold leading-[1.4] text-[#21007c] sm:text-xl">
          {post.title}
        </h3>

        {/* Description + CTA */}
        <div className="flex flex-1 flex-col gap-6">
          <p className="line-clamp-3 flex-1 text-sm font-medium leading-[1.4] text-[#002726]">
            {post.description}
          </p>

          <span className="inline-flex self-start border-b border-[#4b0fea] text-sm font-semibold text-[#041118]">
            {getCtaLabel(post.type)}
          </span>
        </div>
      </div>
    </Link>
  );
}
